export interface ResidenceInterface {
  street: string;
  exteriorNumber: string;
  interiorNumber: string;
  suburb: string;
  postalCode: string;
  city: string;
  state: string;
  timeOccupyingCurrentResidence: string;
  typeOfResidence: string;
}

export interface IncomeInterface {
  typeOfIncomeProof: string;
  companyName: string;
  joiningDate: string;
  netMonthlyIncome: string;
  jobPosition: string;
  jobType: string;
}

export interface IdentityInterface {
  firstName: string;
  secondName?: string;
  paternalLastName: string;
  maternalLastName: string;
  countryCode?: string;
  curp: string;
  ineVoterid: string;
  gender?: string;
  dateOfBirth: string;
  maritalStatus?: string;
  phoneNumber?: string;
  emailId?: string;
  racPromotions?: string;
  rfc: string;
  consentDate?: string;
  productCode?: string;
  source?: string;
  transactionGuidId?: string;
}

// Represents a single record from stg_customer_identity returned by getCustomerStgDetails
export interface StgIdentityRecord {
  stageCustomerIdentityId: number;
  transactionGuid: string | null;
  transactionDate: string;
  livenessChecked: number;
  curpId: string;
  voterId: string;
  rfcId: string;
  agreementId?: string | null;
  idValidationType: string | null;
  selfieValidationtType: string | null;
  identityVerification: string | null;
}

// Shape of the full response from getCustomerStgDetails
export interface StgCustomerResponse {
  stgCustomerProfileId: number;
  firstName: string;
  paternalLastName: string;
  maternalLastName?: string;
  secondName?: string;
  genderType?: string;
  dateOfBirth?: string;
  maritalStatusType?: string;
  phoneNumber?: string;
  emailAddress?: string;
  referralSourceType?: string;
  countryCode?: string;
  productCode?: string;
  customerSource?: string;
  consentDate?: string | null;
  identityInfo: StgIdentityRecord[];
  addressInfo: {
    stageCustomerAddressId?: number;
    addressLine1?: string;
    addressLine2?: string;
    exteriorNumber?: string;
    interiorNumber?: string;
    zipcode?: string;
    city?: string;
    state?: string;
    residenceTenureType?: string;
    residenceType?: string;
  };
  employmentInfo: {
    stageCustomerEmploymentId?: number;
    incomeSourceType?: string;
    companyName?: string;
    employmentBeginDate?: string;
    takeHomePay?: string;
    jobPosition?: string;
    jobType?: string;
  };
}

export interface OptionInterface {
  label: string;
  value: string;
}

// API response shape from CreateCustomerStg / ManageCustomerStaging
export interface CreateCustomerStgResponse {
  status: number;
  data: {
    stgCustomerProfileId?: string;
    stgCustomerIdentityId?: string;
    errors?: Array<{ error: string }>;
  };
}

// Type guard — narrows response data to the success shape (has stgCustomerProfileId)
export function isStgSuccessResponse(
  data: unknown
): data is { stgCustomerProfileId: string; stgCustomerIdentityId?: string } {
  return (
    typeof data === 'object' &&
    data !== null &&
    'stgCustomerProfileId' in data &&
    typeof (data as Record<string, unknown>).stgCustomerProfileId === 'string'
  );
}

// Phone entry in UpdateCustomer payload
export interface CustomerPhone {
  note?: string;
  phoneType?: string;
  callTime?: string;
  phoneId: string;
  phoneNumber: string;
  callTimeType: string;
  primary: string;
  countryCode: string;
  active: string;
}

// Payload for UpdateCustomer (EC flow)
export interface UpdateCustomerPayload {
  customerId: string;
  firstName: string;
  middleInitial?: string | null;
  lastName: string;
  maternalLastName?: string;
  gender?: string;
  dateOfBirth: string;
  maritalStatus?: string;
  phoneNumber: string;
  countryCode?: string;
  emailAddress?: string;
  referralSource?: string;
  taxId?: string;
  taxIdType?: string;
  phones: CustomerPhone[];
  curpId?: string;
  voterId?: string;
}

export interface StateProvince {
  stateProvinceId: string;
  countryId: string;
  abbreviation: string;
  stateProvinceName: string;
  originBasedTax: string;
  taxTemplateId: string | null;
  createdBy: string;
  createdDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
  countryName: string;
  countryCode: string;
}

export interface SecretValues {
  googleMapsKey: string;
  fadToken: string;
  idvsApiKey: string;
  idvsScriptTag: string;
  idvsEndpoint: string;
  environment: string;
  fadAppName: string;
}

export interface SendOTPReq {
  phoneNumber?: string;
  language?: string;
  originCountry?: string;
  customerFullName?: string;
  firstName?: string;
  storeNumber?: string;
  email?: string;
  callCenterDL?: string;
  sendEmail?: boolean;
  sendOtp?: boolean;
}
